var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"md8":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_vm._t("default",function(){return [_c('router-view')]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }